module.exports = __webpack_public_path__ + "static/media/img89.9f6a013c.jpg";